/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import {
  BusinessContextsDocument,
  GetPrimaryBcDocument,
  useSetPrimaryBusinessContextMutation,
} from "~/generated/graphql";
import { SUCCESS_TEXT } from "~/constants";
import { showError, showSuccess } from "~/services/toast";
import { noop } from "~/tools";

type Props = {
  bcId: string;
  onSuccess: () => void;
};

export function useSetPrimaryBusinessContext({
  bcId,
  onSuccess = noop,
}: Props) {
  const [setPrimaryBusinessContext] = useSetPrimaryBusinessContextMutation({
    variables: { id: bcId },
    refetchQueries: [
      { query: BusinessContextsDocument, variables: { limit: 100, page: 0 } },
      { query: GetPrimaryBcDocument },
    ],
  });

  return async function setPrimaryHandler() {
    try {
      const response = await setPrimaryBusinessContext();
      if (response) {
        showSuccess(SUCCESS_TEXT.primaryBusinessContextSet);
        onSuccess();
      }
    } catch (error) {
      showError(
        "Can not set up primary Business Context. Please try again later."
      );
      throw error;
    }
  };
}
